<template>
    <div class="training-wrapper">
        <iframe ref="iframe" :src="trainingUrl" frameborder="0" allow="microphone; camera" allowfullscreen></iframe>
        <AssignModal
            v-if="assignAppointmentUsers"
            v-scroll-lock="assignAppointmentUsers"
            type="appointment"
            :item="training"
            @modalClose="assignAppointmentUsers=null"
        />
    </div>
</template>

<script>
import AssignModal from "@/components/layout/modals/AssignModal.vue";

import axios from 'axios';
export default {
    components:{
        AssignModal
    },
    data(){
        return {
            trainingUrl: '',
            slug: '',
            loading: false,
            training: null,
            assignAppointmentUsers: false,
            spots_left: 0,
        }
    },
    mounted(){
        this.slug = this.$route.params.slug;
        this.fetchTraining();
        window.addEventListener('message', this.handleMessage);
        if(!this.$store.state.header_hidden) this.$store.state.header_hidden = true
        this.$store.state.newTrainingFrame = this.$refs.iframe;
        
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
        if (this.$store.state.newTrainingFrame) {
            this.$store.state.newTrainingFrame = null;
        }
        if(!this.$store.state.header_hidden) this.$store.state.header_hidden = false
    },
    methods: {
        fetchTraining(){
            this.loading = true;
            let query = this.$route.query.mode == 'view' ? '?mode=view' : '';
            axios.get(`${this.$store.state.api_link}/trainings-new/generate-session/${this.slug}${query}`, this.$store.getters.axiosConfig())
                .then((res)=>{
                    this.trainingUrl = res.data.link;
                    this.training = res.data.training;
                    this.loading = false;
                    this.$store.state.loading.loadingDone();
                })
        },
        handleMessage(event) {
            // console.log('Received message:', event.data);
            if (event.data && event.data.type === 'openUserSelectList') {
                // this.$router.push('/home');
                this.assignAppointmentUsers = true;
                this.spots_left = event.data.spots_left;
                this.training.spots_left = event.data.spots_left;
                this.training.added_users = event.data.added_users;
            }
             if (event.data && event.data.type === 'goBack') {
                let id = event.data.training_group;
                let permission = event.data.permission;
                if(id){
                    if(permission == 'edit'){
                        this.$router.push("/edit-group?id=" + id);
                    }
                    else{
                        this.$router.push("/group-trainings?id=" + id);
                    }
                } else {
                    this.$router.back();
                }
            }
            if (event.data && event.data.type === 'goto') {
                let url = event.data.url;
                if(url){
                    this.$router.push(url);
                    this.slug = this.$route.params.slug;
                    this.fetchTraining();
                    this.$store.state.newTrainingFrame = this.$refs.iframe;
                } else {
                    this.$router.back();
                }
            }
            if(event.data == 'appLoaded'){
                this.sendTranslations();
                this.sendSettings();
            }
        },
        sendTranslations(){
            console.log(this.$store.state.translations);
            let translations_obj = {};
            this.$store.state.translations.forEach(element => {
                translations_obj[element.translation_key] = {...element};
            });
            this.$store.state.newTrainingFrame.contentWindow.postMessage({
              type: 'translations',
              translations: translations_obj,
              selected_language: this.$store.state.language
            }, '*');
        },
        sendSettings(){
             this.$store.state.newTrainingFrame.contentWindow.postMessage({
              type: 'backend_link',
              backend_link: this.$store.state.backend_link,
              lms_key: this.$store.state.system_settings.lms_key,
            }, '*');
        }
    }
}
</script>

<style lang="scss" scoped>
.training-wrapper{
    height: 100vh;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    iframe{
        width: 100%;
        height: 100%;
        border: none;
    }
}
</style>